import coreEntry from '@core/entry.js'
import empty from '@core/components/empty.vue'

const header = () => import("@/components/HEAD.vue"); // 首页
const aside = ()=>import("@/components/ASIDE.vue"); // 新高呈 - 左侧菜单
const sideMenu = () => import("@core/components/LEFT.vue"); // 左侧
//const seoSetting = () => import("@/views/settingMan/seoSetting.vue");
const seoSetting = () => import("@core/modules/settingMan/seoSetting.vue");
const adminMan = () => import("@/views/adminMan/adminSetting.vue");
const operaLog = () => import("@/views/log/Log.vue");

const reviewManage = () =>
  import("@/views/plugin/reviewManage/reviewManage.vue");
const businessReminding = () =>
  import("@/views/businessReminding/businessReminding.vue"); //业务提醒
//const appHome = () => import("@/views/appHome/appHome.vue"); //应用首页
const appHome = () => import("@core/modules/appHome/appHome.vue"); //应用首页
const multiFunctionForm = () => import("@/views/multiFunctionForm/multiFunctionForm.vue"); //万能表单
const universalFormJT = () => import("@/views/multiFunctionForm/universalFormJT.vue"); //万能表单

const editPolicy = () => import("@/views/multiFunctionForm/editPolicy.vue"); //编辑隐私政策
const addFormSetting = () =>
  import("@/views/multiFunctionForm/addFormSetting.vue"); //添加表单设置
// 留言
const messageBox = () => import("@/views/messageMan/messageBox.vue");
const messageList = () => import("@/views/messageMan/messageList.vue");
const messageFormList = () => import("@/views/messageMan/messageFormList.vue");
const addMessageForm = () => import("@/views/messageMan/addMessageForm.vue");
//服务网点
const mapLayout = () => import("@/views/mapMan/mapLayout.vue");
const mapList = () => import("@/views/mapMan/mapList.vue");
const mapForm = () => import("@/views/mapMan/mapForm.vue");
const categoryMan = () => import("@/views/mapMan/categoryMan.vue");
const brandMan = () => import("@/views/mapMan/brandMan.vue");
//招聘
const recruitLayout = () => import("@/views/recruitMan/recruitLayout.vue");
const recruitList = () => import("@/views/recruitMan/recruitList.vue");
const recruitForm = () => import("@/views/recruitMan/recruitForm.vue");
const recruitDepartmentMan = () =>
  import("@/views/recruitMan/recruitDepartmentMan.vue");
const applicantList = () => import("@/views/recruitMan/applicantList.vue");
const formSetting = () => import("@/views/recruitMan/formSetting.vue");
//管理员
const adminManage = () => import("@/views/adminManage.vue");
//跨站转发
const forwardManage = () => import("@/views/forwardManage.vue");
//文件库(新）
// const fileManageNew = () => import("@/views/plugin/fileManageNew/fileManage.vue");
//文件库(调用全网文件库）
const fileSetting = () => import("@/views/settingMan/fileSetting.vue");
//会员管理
const memberManage = () => import("@/views/memberManage.vue");
//人员管理定制
const personnelManage = () => import("@/views/personnel.vue");
//数据统计
const statisticAnalysis = () =>
  import("@/views/plugin/statisticAnalysis/statisticAnalysis.vue");
const accessStatistics = () =>
  import("@/views/plugin/statisticAnalysis/accessStatistics.vue");
const downloadStatistic = () =>
  import("@/views/plugin/statisticAnalysis/downloadStatistic.vue");
const statisticDetail = () =>
  import("@/views/plugin/statisticAnalysis/statisticDetail.vue");
const downloadDetail = () =>
  import("@/views/plugin/statisticAnalysis/downloadDetail.vue");
//净值管理
const netWorthLayout = () =>
  import("@/views/plugin/netWorthManage/netWorthLayout.vue");
const netWorthManage = () =>
  import("@/views/plugin/netWorthManage/netWorthManage.vue");
const netWorthDetail = () =>
  import("@/views/plugin/netWorthManage/netWorthDetail.vue");
const bonusManage = () =>
  import("@/views/plugin/netWorthManage/bonusManage.vue");
const holidaySetting = () =>
  import("@/views/plugin/netWorthManage/holidaySetting.vue");
const ETFnetWorthManage = () =>
  import("@/views/plugin/netWorthManage/ETFnetWorthManage.vue");
const ETFnetWorthDetail = () =>
  import("@/views/plugin/netWorthManage/ETFnetWorthDetail.vue");
const ETFstockDetail = () =>
  import("@/views/plugin/netWorthManage/ETFstockDetail.vue");
const trackingDifference = () =>
  import("@/views/plugin/netWorthManage/trackingDifference.vue");

//客户管理
const customerLayout = () =>
  import("@/views/plugin/customerManage/customerLayout.vue");
const customerManage = () =>
  import("@/views/plugin/customerManage/customerManage.vue");
const groupManage = () =>
  import("@/views/plugin/customerManage/groupManage.vue");
const emailNotification = () =>
  import("@/views/plugin/customerManage/emailNotification.vue");
const sendEmail = () => import("@/views/plugin/customerManage/sendEmail.vue");

//人员管理
const personnelLayout = () =>
  import("@/views/plugin/personnelManage/personnelLayout.vue");
const employeeManage = () =>
  import("@/views/plugin/personnelManage/employeeManage.vue");
const addEmployee = () =>
  import("@/views/plugin/personnelManage/addEmployee.vue");
const branchManage = () =>
  import("@/views/plugin/personnelManage/branchManage.vue");
const addBranch = () =>
  import("@/views/plugin/personnelManage/addBranch.vue");
const agentManage = () =>
  import("@/views/plugin/personnelManage/agentManage.vue");
const addAgent = () =>
  import("@/views/plugin/personnelManage/addAgent.vue");
const regionalManage = () =>
  import("@/views/plugin/personnelManage/regionalManage.vue");

//答题管理
const AnswerMain = () => import("@/views/answerMng/Main.vue");
const AnswerList = () => import("@/views/answerMng/AnswerList.vue");
const AnswerPaperList = () => import("@/views/answerMng/AnswerPaperList.vue");
const AnswerPaperForm = () => import("@/views/answerMng/AnswerPaperForm.vue");

export default [
  {
    path: "/appCenter",
    name: "/appCenter",
    redirect: {
      name: "appHome"
    }
  },
  {
    //应用首页
    path: "/appHome",
    name: "appHome",
    components: {
      header: header,
      aside: aside,
      default: appHome
    }
  },

  {
    path: "/layout",
    name: "layout",
    components: {
      header: header,
      aside: aside,
      default: empty,
      left: sideMenu
    },
    children: coreEntry.getModuleConfig('router', [
      'column',
      'content',
      'contentReview',
      'contentRecycleBin',
      'contentSearch',
      'template',
      'field',
      'group',
      'ipBlockList',
      'sensitiveWord',
      'image',
      'video',
      'banner',
      'file'
    ])

  },

  {
    // seo设置
    path: "/seoSetting",
    name: "seoSetting",
    components: {
      header: header,
      aside: aside,
      left: sideMenu,
      default: seoSetting
    },
    meta: {
      root: "/appCenter"
    }
  },
  {
    path: "/adminManage",
    name: "adminManage",
    components: {
      default: adminMan
    },
    meta: {
      root: "/appCenter",
      unGetPermission: true // 不需要获取用户权限
    }
  },
  {
    path: "/operaLog",
    name: "operaLog",
    components: {
      header: header,
      aside: aside,
      default: operaLog,
      left: sideMenu
    },
    meta: {
      root: "/appCenter"
    }
  },
  {
    //审核管理
    path: "/reviewManage",
    name: "reviewManage",
    components: {
      header: header,
      aside: aside,
      default: reviewManage,
      left: sideMenu
    },
    meta: {
      root: "/appCenter"
    }
  },
  {
    //业务提醒
    path: "/businessReminding",
    name: "businessReminding",
    components: {
      header: header,
      aside: aside,
      default: businessReminding,
      left: sideMenu
    },
    meta: {
      title: "业务提醒",
      root: "/appCenter"
    }
  },
  {
    //万能表单
    path: "/omnipotentForm",
    name: "multiFunctionForm",
    components: {
      header: header,
      aside: aside,
      default: multiFunctionForm,
      left: sideMenu
    },
    meta: {
      root: "/appCenter"
    }
  },

  // 新万能表单
  {
    path: "/universalFormJT",
    name: "universalFormJT",
    components: {
      header: header,
      aside: aside,
      default: universalFormJT,
      left: sideMenu
    },
    meta: {
      root: "/appCenter"
    }
  },

  {
    //编辑隐私政策
    path: "/omnipotentForm/editPolicy",
    name: "editPolicy",
    components: {
      header: header,
      aside: aside,
      default: editPolicy,
      left: sideMenu
    },
    meta: {
      root: "/appCenter"
    }
  },
  {
    //添加表单设置
    path: "/omnipotentForm/addFormSetting",
    name: "addFormSetting",
    components: {
      header: header,
      aside: aside,
      default: addFormSetting,
      left: sideMenu
    },
    meta: {
      root: "/appCenter"
    }
  },
  {
    // 人员管理
    path: "/personnelManage",
    name: "personnelManage",
    components: {
      header: header,
      aside: aside,
      default: personnelManage,
      left: sideMenu
    },
    meta: {
      root: "/appCenter"
    }
  },
  {
    // 留言
    path: "/message",
    name: "message",
    redirect: {
      name: "messageList"
    },
    components: {
      header: header,
      aside: aside,
      default: messageBox,
      left: sideMenu
    },
    children: [
      {
        path: "list",
        name: "messageList",
        component: messageList,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "formList",
        name: "messageFormList",
        component: messageFormList,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "addForm",
        name: "addMessageForm",
        component: addMessageForm,
        meta: {
          root: "/appCenter"
        }
      }
    ]
  },
  {
    // 服务网点
    path: "/map",
    name: "map",
    components: {
      header: header,
      aside: aside,
      left: sideMenu,
      default: mapLayout
    },
    redirect: {
      name: "mapList"
    },
    children: [
      {
        path: "mapList",
        name: "mapList",
        component: mapList,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "mapForm",
        name: "mapForm",
        component: mapForm,
        meta: {
          hideMenu: true,
          root: "/appCenter"
        }
      },
      {
        path: "categoryMan",
        name: "categoryMan",
        component: categoryMan,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "brandMan",
        name: "brandMan",
        component: brandMan,
        meta: {
          root: "/appCenter"
        }
      }
    ]
  },
  {
    //招聘
    path: "/recruit",
    name: "recruit",
    components: {
      header: header,
      aside: aside,
      left: sideMenu,
      default: recruitLayout
    },
    redirect: {
      name: "recruitList"
    },
    children: [
      {
        path: "recruitList",
        name: "recruitList",
        component: recruitList
      },
      {
        path: "recruitForm",
        name: "recruitForm",
        component: recruitForm,
        meta: {
          hideMenu: true
        }
      },
      {
        path: "recruitDepartmentMan",
        name: "recruitDepartmentMan",
        component: recruitDepartmentMan
      },
      {
        path: "applicantList",
        name: "applicantList",
        component: applicantList
      },
      {
        path: "formSetting",
        name: "formSetting",
        component: formSetting,
        meta: {
          hideMenu: true
        }
      }
    ]
  },
  {
    path: "/mcenter/adminManage/AdministratorManage",
    name: "mAdminManage",
    components: {
      header: header,
      aside: aside,
      default: adminManage,
      left: sideMenu
    },
    meta: {
      root: "/appCenter"
    }
  },
  {
    path: "/mcenter/forwardManage/forwardLog",
    name: "forwardManage",
    components: {
      header: header,
      aside: aside,
      default: forwardManage,
      left: sideMenu
    },
    meta: {
      root: "/appCenter"
    }
  },
  // {
  //   path: "/fileManageNew",
  //   name: "fileManageNew",
  //   components: {
  //     header: header,
  //     default: fileManageNew,
  //     left: sideMenu
  //   }
  // },
  {
    path: "/fileSetting",
    name: "fileSetting",
    components: {
      header: header,
      default: fileSetting,
      left: sideMenu
    }
  },
  {
    // 会员管理
    path: "/memberManage",
    name: "memberManage",
    components: {
      header: header,
      aside: aside,
      default: memberManage,
      left: sideMenu
    }
  },
  {
    // 数据统计
    path: "/statisticAnalysis",
    name: "statisticAnalysis",
    components: {
      header: header,
      aside: aside,
      default: statisticAnalysis,
      left: sideMenu
    },
    redirect: {
      name: "accessStatistics"
    },
    children: [
      {
        path: "accessStatistics",
        name: "accessStatistics",
        component: accessStatistics,
        meta: {
          root: "/appCenter"
          // keepAlive: true
        }
      },
      {
        path: "downloadStatistic",
        name: "downloadStatistic",
        component: downloadStatistic,
        meta: {
          root: "/appCenter"
          // keepAlive: true
        }
      },
      {
        path: "statisticDetail",
        name: "statisticDetail",
        component: statisticDetail,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "downloadDetail",
        name: "downloadDetail",
        component: downloadDetail,
        meta: {
          root: "/appCenter"
        }
      }
    ]
  },
  {
    // 净值管理
    path: "/netWorth",
    name: "netWorthLayout",
    components: {
      header: header,
      aside: aside,
      default: netWorthLayout,
      left: sideMenu
    },
    redirect: {
      name: "netWorthManage"
    },
    children: [
      {
        path: "netWorthManage",
        name: "netWorthManage",
        component: netWorthManage,
        meta: {
          keepAlive: true,
          root: "/appCenter"
        }
      },
      {
        path: "netWorthDetail",
        name: "netWorthDetail",
        component: netWorthDetail,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "ETFnetWorthDetail",
        name: "ETFnetWorthDetail",
        component: ETFnetWorthDetail,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "ETFstockDetail",
        name: "ETFstockDetail",
        component: ETFstockDetail,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "trackingDifference",
        name: "trackingDifference",
        component: trackingDifference,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "bonusManage",
        name: "bonusManage",
        component: bonusManage,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "holidaySetting",
        name: "holidaySetting",
        component: holidaySetting,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "ETFnetWorthManage",
        name: "ETFnetWorthManage",
        component: ETFnetWorthManage,
        meta: {
          keepAlive: true,
          root: "/appCenter"
        }
      }
    ]
  },
  {
    // 客户管理
    path: "/customer",
    name: "customerLayout",
    components: {
      header: header,
      aside: aside,
      default: customerLayout,
      left: sideMenu
    },
    redirect: {
      name: "customerManage"
    },
    children: [
      {
        path: "customerManage",
        name: "customerManage",
        component: customerManage,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "groupManage",
        name: "groupManage",
        component: groupManage,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "emailNotification",
        name: "emailNotification",
        component: emailNotification,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "sendEmail",
        name: "sendEmail",
        component: sendEmail,
        meta: {
          hideMenu: true,
          root: "/appCenter"
        }
      }
    ]
  },
  {
    // 人员管理
    path: "/personnel",
    name: "personnelLayout",
    components: {
      header: header,
      aside: aside,
      default: personnelLayout,
      left: sideMenu
    },
    redirect: {
      name: "employeeManage"
    },
    children: [
      {
        path: "employeeManage",
        name: "employeeManage",
        component: employeeManage,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "addEmployee",
        name: "addEmployee",
        component: addEmployee,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "branchManage",
        name: "branchManage",
        component: branchManage,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "addBranch",
        name: "addBranch",
        component: addBranch,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "agentManage",
        name: "agentManage",
        component: agentManage,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "addAgent",
        name: "addAgent",
        component: addAgent,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "regionalManage",
        name: "regionalManage",
        component: regionalManage,
        meta: {
          hideMenu: true,
          root: "/appCenter"
        }
      }
    ]
  },
  {
    // 答题管理
    path: "/answerMng",
    name: "answerMng",
    components: {
      header: header,
      aside: aside,
      left: sideMenu,
      default: AnswerMain
    },
    redirect: {
      name: "answerList"
    },
    children: [
      {
        path: "answerList",
        name: "answerList",
        component: AnswerList,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "answerPaperList",
        name: "answerPaperList",
        component: AnswerPaperList,
        meta: {
          root: "/appCenter"
        }
      },
      {
        path: "answerPaperForm",
        name: "answerPaperForm",
        component: AnswerPaperForm,
        meta: {
          root: "/appCenter",
          hideMenu: true
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/appCenter.js